import { SelectChangeEvent, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ServiceContext } from "../../Contexts/ServiceContext";
import { useLoading } from "../../Hooks/useLoading";
import { GLOBALS } from "../../Models/Globals";
import { IYearFilterProps } from "./IYearFilter";
import moment from "moment";



export const YearFilter = ({

    OnSelectionChange,
    Key,
    Label

}: IYearFilterProps) => {

    const { SrvContext } = useContext(ServiceContext);
    const { t, i18n } = useTranslation();
    const [isLoading, SetIsLoading] = useLoading();
    const [currentYear, setCurrentYear] = useState<string>(GLOBALS.NO_SELECTED_OPTION.toString());


    const Initialize = async () => {

        await i18n.changeLanguage(SrvContext.WindowData.sccoReportsRender.idiomaCode);
        SetIsLoading(false);

    };

    useEffect(() => {

        Initialize();

    }, []);

    const onYearChange = (event: SelectChangeEvent) => {

        const selectedValue: number = event.target.value as any;

        setCurrentYear(event.target.value);
        if (OnSelectionChange) {
            OnSelectionChange(selectedValue);
        }

    };

    const getYearOptions = () => {

        const options = [];
        let initialYear = moment().year();
        for (let index = 0; index < SrvContext.WindowData.sccoReportsRender.filterYears; index++) {
            options.push(initialYear--);
        }
        return options;

    };


    return (
        <FormControl fullWidth>
            <InputLabel id="year-filter">{Label ? Label : t('label-year-filter')}</InputLabel>
            <Select
                labelId="year-filter"
                id="year-filter-data"
                value={currentYear}
                onChange={onYearChange}
            >
                <MenuItem value={GLOBALS.NO_SELECTED_OPTION}>{t('label-show-all')}</MenuItem>
                {
                    getYearOptions().map((year, index) => (
                        <MenuItem value={year} key={Key ? `${Key}-${index}` : `yearOption-${index}`}>{year}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    );

};